import v2Axios from "../v2Axios";
import { CONFIG } from "../../config";
import { toPositiveId } from "../../utils/ids";
// moduleId is the video id (the backend resolves the owning course from it). A missing or
// 0 id has no module, so no request is made for it.
export const downloadModuleURLService = async (moduleId) => {
	const videoId = toPositiveId(moduleId);
	if (videoId === null) {
		return [];
	}
	try {
		const response = await v2Axios.get(
			`${CONFIG.COURSEURL}/api/v2/modules/get-module/` + videoId
		);
		return response.data;
	} catch (error) {
		// returning blank array after getting server and internet error
		return [];
	}
};
